import classNames from 'classnames';
import styled from 'styled-components';

import Button, { Props as OriginalProps } from 'atoms/buttons/Button';

const Override = styled(Button)`
  &&,
  &&:hover,
  &&:focus {
    color: var(--c-neutral-900);
    border: 2px solid transparent;
    background:
      linear-gradient(var(--c-neutral-100), var(--c-neutral-100)) padding-box,
      linear-gradient(
          0deg,
          rgba(var(--c-rgb-rivals-arena), 0.5),
          rgba(var(--c-rgb-rivals-arena), 1)
        )
        border-box;

    &.active {
      color: var(--c-neutral-100);
      background: var(--c-rivals-arena);
    }
  }
`;

type Props = Omit<OriginalProps, 'color'> & { active?: boolean };
export const ArenaButton = ({ active, className, ...rest }: Props) => {
  return <Override {...rest} className={classNames(className, { active })} />;
};
